import React from 'react'
import Tooltip  from '@material-ui/core/Tooltip';
import { IconButton } from '@material-ui/core';

export default ({ children, onClick, tip,btnClassname, tipClassName}) => (
    <Tooltip title={tip} className={tipClassName} placement='top'>
        <IconButton onClick={onClick} className={btnClassname}>
            {children}
        </IconButton>
    </Tooltip>
)
